import { render, staticRenderFns } from "./DownIndicator.vue?vue&type=template&id=62852e2c&scoped=true&"
import script from "./DownIndicator.vue?vue&type=script&lang=js&"
export * from "./DownIndicator.vue?vue&type=script&lang=js&"
import style0 from "./DownIndicator.vue?vue&type=style&index=0&id=62852e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62852e2c",
  null
  
)

export default component.exports